import { CanDeactivateFn } from '@angular/router';

/** En side med ændringer, der kan gå tabt ved navigation. Returnerer om der må navigeres væk. */
export interface HasUnsavedChanges {
  confirmLeave(): boolean | Promise<boolean>;
}

// Advarer om ugemte ændringer ved al navigation væk fra siden: tilbage-knappen, menuen og browserens tilbage.
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = component => component.confirmLeave();
